module.exports = __webpack_public_path__ + "static/img/app_ivoice_en.bdb0290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/app_ivoice_en.png
// module id = 451
// module chunks = 0